<template>
  <component :is="layout">
    <div class="container">
      <transition name="fade" mode="out-in">
          <router-view/>
      </transition>
      </div>
  </component>
</template>
<script>
const defaultLayout = 'auth'

export default {
  data () {
    return {}
  },
  mounted () {
  },
  methods: {
  },
  computed: {
    layout () {
      return (this.$route.meta.layout || defaultLayout) + '-layout'
    }
  }
}
</script>

<style lang="scss">
#dsy,
html,
body {
  height: 100%;
}
</style>
